// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"518":"258a0498","689":"258a0498","922":"56db86f3","956":"1dc71fd2"}[chunkId] + ".chunk.css";
};